module.exports = __webpack_public_path__ + "img/anli-6.348809e4.jpg";